import React, { useState, useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../pages/BreadCrumb";
import { cartContext } from "../services/userHandler";
import { GetData, PostData } from "../services/SendData";
import {
    getConfigData,
    clone,
    uriSegment,
    IsThisItemSelected,
    countCartItems,
    VerticallyCenteredModal,
    getNewPermalink,
} from "../services/Helper";

var initData = {
    healthArticle: {
        data: null,
        isDarty: true,
        altMessage: "",
        msgcode: 0,
        count: 0,
    },
};

var queryStarted = {
    getHealthArticle: { list: false, timeout: null },
    initCall: true,
};

let objUserInput = {
    searchText: "",
    healthConditions: [],
};

const configData = getConfigData();

function HealthArticleDetails() {
    const { pathname } = useLocation();
    const [healthArticle, setHealthArticle] = useState(initData.healthArticle);

    function getDetails(param) {
        //fnFeedBack, showLoder, force
        // ------------ initialization ------------
        param = typeof param !== "undefined" ? param : {};
        param.showLoder =
            typeof param.showLoder !== "undefined" ? param.showLoder : false;
        param.force = typeof param.force !== "undefined" ? param.force : false;
        param.fnFeedBack =
            typeof param.fnFeedBack !== "undefined" ? param.fnFeedBack : null;
        param.pageNumber =
            typeof param.pageNumber !== "undefined" ? param.pageNumber : 1;
        //param.healthCodition = typeof (param.healthCodition) !== 'undefined' ? param.healthCodition : [];
        // console.log('healthArticle:-', 'listBooking.isDarty:', healthArticle.isDarty, 'force', param.force);
        if (!healthArticle.isDarty && !param.force) {
            console.log("healthArticle:-", 1);
            return false;
        }
        //  listBooking, setListBooking
        // ------------ haldeling force &&  ------------

        if (queryStarted.getHealthArticle.list) {
            console.log("healthArticle:-", 2);
            if (param.force) {
                queryStarted.getHealthArticle.timeout = window.setTimeout(
                    function () {
                        getDetails(param);
                    },
                    1500
                );
            }
            return false;
        }
        console.log("healthArticle:-", 3);
        let selRC = uriSegment(pathname, 2);

        if (queryStarted.getHealthArticle.timeout) {
            window.clearTimeout(queryStarted.getHealthArticle.timeout);
        }

        var apiSegment = "/article/getHealthArticles";
        apiSegment += "/" + selRC;

        queryStarted.getHealthArticle.list = true;
        //console.log('healthArticle:-', 'apiSegment ', apiSegment);
        // console.log('getHealthArticle:',apiSegment);
        // return false;

        GetData(apiSegment, configData, param.showLoder).then((result) => {
            console.log(result);
            var objArticle = {};
            objArticle = clone(initData.healthArticle);
            objArticle.msgcode = result?.msgcode; //clone(result);
            objArticle.data = clone(result?.results);
            objArticle.count = result?.results?.count;
            objArticle.isDarty = false;
            objArticle.altMessage =
                result?.msgcode > 0
                    ? ""
                    : result?.msgtext + ". Please modify your search.";
            setHealthArticle(objArticle);

            if (typeof param.fnFeedBack === "function") {
                param.fnFeedBack();
            }

            window.setTimeout(function () {
                queryStarted.getHealthArticle.list = false;
            }, 1000);
        });
        return false;
    }

    useEffect(() => {
        // queryStarted.initCall = false;
        getDetails({ force: false, showLoder: true });
    }, []);

    return (
        <>
            <Container className="min-hight-article">
                <section className="breadcrumb-section">
                    <BreadCrumb />
                </section>
                {/* {console.log('healthArticle :', healthArticle)} */}
                <div className="article-details">
                    {(healthArticle?.count && (
                        <img
                            src={healthArticle?.data?.articles[0]?.Thumbnail}
                            alt={
                                healthArticle?.data?.articles[0]?.Content
                                    ?.English?.Title
                            }
                        />
                    )) || <>&nbsp;</>}
                </div>

                <h1 className="article-heading">
                    {healthArticle?.data?.articles[0]?.Content?.English?.Title}
                </h1>
                <div
                    className="articledetails-content"
                    dangerouslySetInnerHTML={{
                        __html: healthArticle?.data?.articles[0]?.Content
                            ?.English?.Description[0]?.Content,
                    }}
                ></div>
            </Container>
        </>
    );
}

export default HealthArticleDetails;
